import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  '&.MuiLinearProgress-colorPrimary': {
    backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 700],
  },
  '& .MuiLinearProgress-bar': {
    borderRadius: 5,
    backgroundColor: '#1a90ff',
  },
}));

export default function CustomizedProgressBars(prop) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <h5><img loading="lazy" src={prop.image} alt={prop.name} /> {prop.name} </h5>
      <BorderLinearProgress variant="determinate" value={prop.points * 10} />
    </Box>
  );
}
